module.exports = __webpack_public_path__ + "static/TiemposHeadline-Light-8bcb73eed512b6761cda1fec20027f08.woff";